import { ProductManagementSearchResult } from "src/app/ui/components/pbm/product-management/search-product/product-management-search-result";
import { AbstractParser } from "../../parser";
import { parseProductManagementSearchResult } from "./product-management-parse-funtions";

export class SearchProductsParser extends AbstractParser<ProductManagementSearchResult> {
  public parse(payload: any): ProductManagementSearchResult {
    return parseProductManagementSearchResult(payload);
  }
}
